import { useState } from "react";
import { jsPDF } from "jspdf";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";
import { R } from "../../utils/helpers";import "../../assets/styles/Employee/EmpPayrollPage.css";

function EmpPayrollPage() {
  const { empPayslips, empInfo, empAdvances } = useEmployeeData();
  const [tab, setTab] = useState("overview");
  const latest = empPayslips.length > 0 ? empPayslips[0] : null;

  const toAmount = (v) => Number(String(v ?? 0).replace(/,/g, "")) || 0;

  const amountToWords = (num) => {
    const n = Math.floor(Number(num) || 0);
    if (n === 0) return "Zero Rupees Only";
    const a = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const two = (x) => x < 20 ? a[x] : `${b[Math.floor(x / 10)]}${x % 10 ? ` ${a[x % 10]}` : ""}`;
    const three = (x) => {
      const h = Math.floor(x / 100);
      const r = x % 100;
      return `${h ? `${a[h]} Hundred${r ? " " : ""}` : ""}${r ? two(r) : ""}`.trim();
    };
    const crore = Math.floor(n / 10000000);
    const lakh = Math.floor(n % 10000000 / 100000);
    const thousand = Math.floor(n % 100000 / 1000);
    const rest = n % 1000;
    const parts = [];
    if (crore) parts.push(`${three(crore)} Crore`);
    if (lakh) parts.push(`${three(lakh)} Lakh`);
    if (thousand) parts.push(`${three(thousand)} Thousand`);
    if (rest) parts.push(three(rest));
    return `${parts.join(" ")} Rupees Only`;
  };

  const loadLogoDataUrl = async () => {
    try {
      const res = await fetch("/logo.png");
      if (!res.ok) return null;
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = () => resolve(null);
        fr.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  };

  const addPayslipPdf = (doc, p, yearVal, title = "PAYSLIP", logoDataUrl = null) => {
    const basic = toAmount(p.basic);
    const hra = toAmount(p.hra);
    const bonus = toAmount(p.bonus);
    const otherAllowance = toAmount(p.otherAllowance);
    const totalEarning = toAmount(p.totalEarning || p.gross);
    const pf = toAmount(p.pf);
    const esi = toAmount(p.esi);
    const professionTax = toAmount(p.professionTax);
    const totalDeduction = toAmount(p.totalDeduction || p.ded);
    const net = toAmount(p.net);

    // Header section
    doc.setFillColor(15, 23, 42);
    doc.rect(0, 0, 210, 28, "F");
    if (logoDataUrl) {
      try {doc.addImage(logoDataUrl, "PNG", 14, 6, 14, 14);} catch {}
    }
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("AMSHRMS", 32, 14);
    doc.setFontSize(9);
    doc.text("PAYSLIP", 32, 20);
    doc.setTextColor(17, 24, 39);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Employee Name: ${empInfo?.name || "-"}`, 14, 38);
    doc.text(`Employee ID: ${empInfo?.id || "-"}`, 14, 44);
    doc.text(`Designation: ${empInfo?.role || "-"}`, 14, 50);
    doc.text(`Pay Period: ${p.month} ${yearVal}`, 14, 56);
    doc.line(14, 60, 196, 60);

    doc.setFont("helvetica", "bold");
    doc.text("Earnings", 14, 70);
    doc.text("Amount", 78, 70);
    doc.text("Deductions", 112, 70);
    doc.text("Amount", 176, 70);

    doc.setFont("helvetica", "normal");
    doc.text("Basic Salary", 14, 79);
    doc.text(`${R}${basic.toLocaleString("en-IN")}`, 78, 79);
    doc.text("PF", 112, 79);
    doc.text(`${R}${pf.toLocaleString("en-IN")}`, 176, 79);

    doc.text("HRA", 14, 86);
    doc.text(`${R}${hra.toLocaleString("en-IN")}`, 78, 86);
    doc.text("ESI", 112, 86);
    doc.text(`${R}${esi.toLocaleString("en-IN")}`, 176, 86);

    doc.text("Bonus", 14, 93);
    doc.text(`${R}${bonus.toLocaleString("en-IN")}`, 78, 93);
    doc.text("Professional Tax", 112, 93);
    doc.text(`${R}${professionTax.toLocaleString("en-IN")}`, 176, 93);

    doc.text("Other Allowance", 14, 100);
    doc.text(`${R}${otherAllowance.toLocaleString("en-IN")}`, 78, 100);
    doc.text("Total Deduction", 112, 100);
    doc.text(`${R}${totalDeduction.toLocaleString("en-IN")}`, 176, 100);

    doc.setDrawColor(220, 226, 236);
    doc.line(14, 106, 196, 106);

    doc.setFont("helvetica", "bold");
    doc.text("Total Earning", 14, 115);
    doc.text(`${R}${totalEarning.toLocaleString("en-IN")}`, 78, 115);
    doc.text("Net Amount", 112, 115);
    doc.text(`${R}${net.toLocaleString("en-IN")}`, 176, 115);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Net Amount In Words: ${amountToWords(net)}`, 14, 124);
    doc.text(`Generated on ${new Date().toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" })}`, 14, 132);

    // Footer section
    doc.setFillColor(241, 245, 249);
    doc.rect(0, 285, 210, 12, "F");
    doc.setFontSize(8);
    doc.setTextColor(71, 85, 105);
    doc.text("This is a system generated payslip. For queries contact HR.", 14, 292);
    doc.setTextColor(17, 24, 39);
  };

  const handleDownload = async (p) => {
    const y = p.year || new Date().getFullYear();
    const doc = new jsPDF();
    const logoDataUrl = await loadLogoDataUrl();
    addPayslipPdf(doc, p, y, "PAYSLIP", logoDataUrl);
    doc.save(`payslip-${p.month}-${y}.pdf`);
  };

  const handleDownloadHistoryPdf = () => {
    if (!empPayslips.length) return;
    const doc = new jsPDF();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("AMSHRMS - Payslip History", 14, 16);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Employee: ${empInfo?.name || "-"} (${empInfo?.id || "-"})`, 14, 24);
    doc.text(`Generated: ${new Date().toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" })}`, 14, 30);

    let y = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Month", 14, y);
    doc.text("Gross", 64, y);
    doc.text("Deduction", 104, y);
    doc.text("Net", 148, y);
    doc.text("Status", 178, y);
    y += 6;
    doc.setFont("helvetica", "normal");

    empPayslips.forEach((p) => {
      if (y > 280) {
        doc.addPage();
        y = 20;
      }
      doc.text(`${p.month} ${p.year || ""}`.trim(), 14, y);
      doc.text(`${R}${p.gross}`, 64, y);
      doc.text(`${R}${p.ded}`, 104, y);
      doc.text(`${R}${p.net}`, 148, y);
      doc.text(String(p.status || "processed"), 178, y);
      y += 6;
      doc.setDrawColor(235, 238, 244);
      doc.line(14, y - 2, 196, y - 2);
    });

    doc.save(`payslip-history-${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  return (
    <div>
      <div className="tab-bar">
        <button className={`tab-btn${tab === "overview" ? " active" : ""}`} onClick={() => setTab("overview")}>Overview</button>
        <button className={`tab-btn${tab === "history" ? " active" : ""}`} onClick={() => setTab("history")}>Payslip History</button>
        <button className={`tab-btn${tab === "advances" ? " active" : ""}`} onClick={() => setTab("advances")}>Salary Advances</button>
      </div>
      {tab === "overview" &&
      <div className="card animate-in">
          <div className="card-header"><div className="card-title">{latest ? `${latest.month} ${latest.year || "2026"}` : "No Payslips"}</div><div className="card-subtitle">Latest Payslip</div></div>
          <div className="card-body emppayrollpage-inline-1">
            <div className="emppayrollpage-inline-2">{R}{latest ? latest.net : "0"}</div>
            <div className="emppayrollpage-inline-3">Net Pay{latest ? ` | ${latest.status}` : ""}</div>
            <div className="emppayrollpage-inline-4">
              <div><div className="emppayrollpage-inline-5">{R}{latest ? latest.gross : empInfo.gross}</div><div className="emppayrollpage-inline-6">Gross</div></div>
              <div><div className="emppayrollpage-inline-7">{R}{latest ? latest.ded : empInfo.ded}</div><div className="emppayrollpage-inline-8">Deductions</div></div>
            </div>
            {latest && <button className="btn-outline emppayrollpage-inline-9" onClick={() => handleDownload(latest)}><Icons.Download /> Download Payslip</button>}
          </div>
        </div>
      }
      {tab === "history" &&
      <div className="card animate-in">
          <div className="card-header">
            <div className="card-title">Payslip History</div>
            <div className="card-subtitle">{empPayslips.length} records</div>
            {!!empPayslips.length && <button className="btn-outline" onClick={handleDownloadHistoryPdf}><Icons.Download /> Download Log PDF</button>}
          </div>
          <div className="card-body emppayrollpage-inline-10">
            {empPayslips.length === 0 ? <div className="emppayrollpage-inline-11">No payslips found</div> :
          <table className="data-table">
                <thead><tr><th>Month</th><th>Gross</th><th>Deductions</th><th>Net</th><th>Status</th><th>Action</th></tr></thead>
                <tbody>{empPayslips.map((p, i) =>
              <tr key={i}><td className="emppayrollpage-inline-12">{p.month} {p.year || ""}</td><td>{R}{p.gross}</td><td>{R}{p.ded}</td><td className="emppayrollpage-inline-13">{R}{p.net}</td><td><span className="status-badge approved"><span className="sb-dot" />{p.status}</span></td><td><button className="btn-outline emppayrollpage-inline-14" onClick={() => handleDownload(p)}><Icons.Download /> Download</button></td></tr>
              )}</tbody>
              </table>}
          </div>
        </div>
      }
      {tab === "advances" &&
      <div className="card animate-in">
          <div className="card-header"><div className="card-title">My Salary Advances</div><div className="card-subtitle">{empAdvances.length} requests</div></div>
          <div className="card-body emppayrollpage-inline-15">
            {empAdvances.length === 0 ?
          <div className="emppayrollpage-inline-16">No advance requests found</div> :

          <table className="data-table">
                <thead><tr><th>ID</th><th>Amount</th><th>Type</th><th>EMI</th><th>Remaining</th><th>Status</th></tr></thead>
                <tbody>{empAdvances.map((a, i) =>
              <tr key={i}><td className="emppayrollpage-inline-17">{a.adv_id || a.id}</td><td className="emppayrollpage-inline-18">{a.amt || `${R}${a.amount}`}</td><td>{a.type}</td><td>{a.emi}</td><td>{a.remaining}</td><td><span className={`status-badge ${a.status === "active" ? "approved" : a.status}`}><span className="sb-dot" />{a.status}</span></td></tr>
              )}</tbody>
              </table>
          }
          </div>
        </div>
      }
    </div>);

}

export default EmpPayrollPage;